export const ANCILLARY_REPORT = 'ancillary-report'

export const ancillaryReportPath = (): string => `/${ANCILLARY_REPORT}`
